<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0">
  <link rel="stylesheet" href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/3.1.0/css/font-awesome.min.css" />
  </head>

  <body>
    <div class="page view-details-courrier">

      <div class="d-flex justify-content-center">
        <h5 id="heading" class="text-light" style="font-size: 12px;">Informations sur :  {{data.prenom}} {{data.nom}}</h5>
        <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()" >
          <i class="fas fa-times text-light" style="font-size: 1.5rem; "></i>
        </button>
        
      </div>
      <div class="addButton  text-nowrap  mr-2"  >
        <div *ngIf="data != null" class="button b2  w-auto text-light  float-right mt-3 mb-1 " (click)="onSubmit(form)"  style=" background:#f3a14c !important; ">
          <i class="fas fa-solid fa-save float-left mt-1" style="font-size: 20px;"></i></div>
      </div> <br>
      <form #form="ngForm"   novalidate id="msform" >
        
         <!-- tabs -->
         <div class="pcss4t pcss4t-effect-scale pcss4t-theme-1">
           <!-- <input type="radio" name="pcss4t" checked  id="tab1"class="tab-content-first">
           <label for="tab1">Elements du dossier</label>
  
           <input type="radio" name="pcss4t"   id="tab2"class="tab-content-2">
  
           <label for="tab2">identification parties prenantes</label> -->
           <input type="radio" name="pcss4t" checked   id="_tab1"class="_tab-content-first">
           <label for="_tab1">Détails</label>
  
           <input type="radio" name="pcss4t"    id="_tab2"class="_tab-content-2">
           <label for="_tab2">Autres informations</label>
  
           <ng-container *ngIf="data.utilisateur == actual_user">
            <input type="radio" name="pcss4t"    id="_tab3"class="_tab-content-3">
            <label for="_tab3">Authentification</label>
           </ng-container>
           
  
  
  
           <!-- <input type="radio" name="pcss4t" id="_tab3" class="_tab-content-3">
           <label for="_tab3"><i ></i>Liste condamnations</label>
  
           <span class="text-center">Liste chambre/section</span>
  
           <li class="active" id="step1"><strong>Détails </strong></li>
           <li class="active" id="step2"><strong>Autres informations </strong></li>
           <li id="step3" *ngIf="IS_NEW_EMPLOYE"><strong>Paramétres utilisateur</strong></li> -->
  
           <ul>
  
  
             <li class="_tab-content _tab-content-first typography" style="overflow: auto;">
               <br>
               <fieldset>
                <div class="form-card">
  
                  <div class="row">
                    <div class="col-md-6 mb-3" style="padding: 0 5px 0 0;">
                        <label class="fieldlabels">Prenom: *</label>
                        <input  type="text" class="form-control" name="prenom" [(ngModel)]="data.prenom" ngModel required />
        
                        <label class="fieldlabels">Genre: </label>
                        <select  class="custom-select" id="inputGroupSelect01"   name="genre" [(ngModel)]="data.genre"  required>
                          <!-- <option selected value="{{data.genre}}"> {{data.genre}}</option> -->
                          <option value="Homme">Homme</option>
                          <option value="Femme">Femme</option>
                        </select>
        
                        <label class="fieldlabels">Date de naissance: </label>
                        <input  type="date" class="form-control"  [(ngModel)]="data.date_de_naissance" name="date_de_naissance" />
        
                        <label class="fieldlabels">Domicile actuel: </label>
                        <input  type="text" class="form-control" name="domicile" [(ngModel)]="data.domicile" />
        
                    </div>
        
                    <div class="col-md-6 mb-3 d-flex flex-column">
                      <label class="fieldlabels">Nom: *</label>
                      <input  type="text" class="form-control" name="nom" [(ngModel)]="data.nom" ngModel required />
        
                      <label class="fieldlabels">Nationalités: </label>
                      <input  type="text" class="form-control" name="nationalités" [(ngModel)]="data['nationalités']"  />
        
                      <label class="fieldlabels">Lieu de naissance: </label>
                      <input  type="text" class="form-control" name="lieu_de_naissance" [(ngModel)]="data.lieu_de_naissance" />
        
                      <label class="fieldlabels">Status matrimoniale: </label>
                      <select class="custom-select" id="inputGroupSelect01" [(ngModel)]="data.status_marital"  name="status_marital" >
                        <!-- <option selected value="{{data.lieu_de_naissance}}">{{data.lieu_de_naissance}}</option> -->
                        <option value="célibataire">Célibataire</option>
                        <option value="marié(e)">Marié(e)</option>
                        <option value="divorcé(e)">Divorcé(e)</option>
                        <option value="veuf/veuve">Veuf/Veuve</option>
                      </select>
        
                    </div>
                </div>
                <div class="d-flex flex-column">

                  <!-- <a *ngIf="data.signature?.signature"  class="text-secondary font-weight-bold text-xs mt-4" data-toggle="tooltip" (click)="openModalVisualPiece(data.signature?.signature)"   data-original-title="Edit user">
                    <i class="fas fa-solid fa-eye text-primary float-right" style="font-size: 20px;"></i>
                  </a> -->
                  <span class="mb-1" style="cursor: pointer;">signature: <a (click)="openSignatureModal(data.signature?.signature ? false : true)" >Nouvelle signature</a></span>

                  <img  *ngIf="data.signature?.signature != null" style="width: 200px;height: 150px;" [src]="default_signature" alt="signature ADG" />


                </div>
               
                
                <!-- <div class="d-flex">
                  <label class="custom-file-upload" for="file3">
                    <div class="icon">
                        <i class="fas fa-regular fa-file"></i>
                    </div>
                   
                    <div class="text text-nowrap">
                      <span class="file-label" style="font-size: 11px;">{{ data.signature?.signature ? data.signature.signature : 'Aucune signature' }}</span>
                    </div>
                    <input  id="file3" class="form-control file-input"  name="attach_mmiv"  />
                    
                  </label>&nbsp;
                  <a *ngIf="data.signature?.signature"  class="text-secondary font-weight-bold text-xs mt-4" data-toggle="tooltip" (click)="openModalVisualPiece(data.signature?.signature)"   data-original-title="Edit user">
                    <i class="fas fa-solid fa-eye text-primary float-right" style="font-size: 20px;"></i>
                  </a>
                </div> -->
                
                </div>
                
            </fieldset>
              </li>
  
  
               <li class="_tab-content _tab-content-2 typography" style="overflow: auto;">
                <br>
                <fieldset>
                  <div class="form-card">
  
  
                    <div class="d-flex justify-content-center flex-wrap">
                      <div class="col-md-5 mb-3" style="padding: 0 5px 0 0;">
                          <label class="fieldlabels">Email professionnel: *</label>
                          <input  type="email" class="form-control" name="mail_professionel" [(ngModel)]="data.mail_professionel" required />
        
                      </div>
        
                      <div class="col-md-5 mb-3 d-flex flex-column">
                        <label class="fieldlabels">Profil: *</label>

                        <input
                          type="text"
                          [(ngModel)]="__selectedProfile"
                          [(ngModel)]="data.profil_system"
                          id="_addprofilInput"
                          name="profil_metier"
                          class="form-control"
                          placeholder="Profil"
                          (focus)="onFocus('_addprofilInput')"
                          (blur)="onBlur('_addprofilInput')"
                          (input)="onInput('_addprofilInput', $event)"
                        />
                        <div class="list_item_profil dropdown-menu" *ngIf="isProfilListVisible">
                          <ul>
                            <div class="d-flex justify-content-center align-items-center bg-dark text-light p-2"> 
                              <span class="text-center align-middle">Liste profils</span>

                            </div>  
                            <li *ngFor="let item of filteredProfiles" (click)="selectProfile(item,'_addprofilInput')">
                              {{ item.name }}
                            </li>
                          </ul>
                        </div>
                        <p class=" text-primary" *ngIf="noMatchVisible" style=" cursor: pointer;" (click)="addItemToApi(searchTerm, '_addprofilInput')">
                          Ajouter "<span class="new-item text-dark">{{ searchTerm }}</span>"
                        </p>
                        <!-- <input type="text" [(ngModel)]="__selectedProfile" id="_addprofilInput"  name="profil_system" [(ngModel)]="data.profil_system"   class="form-control" placeholder="Profil" />
                          <div class="list_item_profil dropdown-menu" style="display: none;">
                            <ul>
                              <span class="text-center">Liste profils</span>
                            </ul>
                          </div> -->
          
                          
                      </div>
                      <!-- <div class="justify-content-center">
                        <label class="fieldlabels">Signature: {{signature_user}}</label>&nbsp;
                        <app-signature-pad></app-signature-pad>
                      </div> -->
                      
                    </div>
                    <div class="row">
                      <div class="col shadow">
                         <label class="fieldlabels bg-dark text-light">Identifications:</label>&nbsp;&nbsp; <i class="fas fa-solid fa-plus text-success" id="addRowBtn" style="font-size: 20px;"  ></i>
        
                        <div class="container">

                          <table id="myTable" class="table table-striped text-center col-md-11 col-lg-11 col-sm-11" style="font-size: 10px;">
                            <thead>
                                <tr>
                                  <th>Type</th>
                                    <th>Numéro identification</th>
                                    
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of data.identifications">

                                <td>  
                                  <select class="custom-select" id="inputGroupSelect01"  name="type_didentification" >
                                    <option [value]="item.type">{{item.type}}</option>
                                  </select>
                                </td>
                                <td> <input class="form-control" type="text" name="numero_didentification" [value]="item.numero_identifications"  /></td>
                               
                                  
                                
                                <td class="col-md-2 col-sm-2">
                                  <i class="fas fa-trash text-danger delete" style="font-size: 20px; cursor:pointer;"></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          
                        </div>
                      </div> &nbsp; &nbsp;
        
                    </div> <br>
        
        
                    <div class="d-flex  flex-column col-md-12 col-lg-12">
        
                    <div class="shadow col-md-12 col-lg-12 col-sm-12">
                      <label class="fieldlabels  bg-dark text-light">Affiliations: </label> &nbsp;&nbsp; <i class="fas fa-solid fa-plus text-success" id="addRowBtn_aff" style="font-size: 20px;"  ></i>
                      <table id="myTable_affiliation" class="table table-striped text-center col-md-11 col-lg-11 col-sm-11" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th>Lien</th>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of data.affiliation">
                            
                            <td> 
                              <select class="custom-select" id="inputGroupSelect01"  name="lien" >
                                <option [value]="item.lien">{{item.lien}}</option>
                              </select>
                            </td>
                            <td><input class="form-control" type="text" name="nom" [value]="item.nom"   /></td>
                            <td><input class="form-control" type="text" name="prenom" [value]="item.prenom"  /></td>
                            <td class="col-md-2 col-sm-2"><i class="fas fa-solid fa-trash text-danger delete-aff" style="font-size: 20px;"></i></td> 
                              
                            
                          </tr>
                        </tbody>
                      </table>
                      
                    </div>
                      &nbsp;&nbsp;
                    <div  class="col-md-12 col-lg-12 col-sm-12 shadow">
                      <label class="fieldlabels  bg-dark text-light">Contact: </label> &nbsp;&nbsp; <i class="fas fa-solid fa-plus text-success" id="addRowBtn_contact"  style="font-size: 20px;"></i>
                      <table id="myTable_contact" class="table table-striped text-center col-md-11 col-lg-11 col-sm-11" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Libellé</th>
                                <th>Valeur</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>

                          <tr *ngFor="let item of data.contact">
                            <td>
                              <select class="custom-select" id="inputGroupSelect01"  name="type" >
                                <option [value]="item.type">{{item.type}}</option>
                              </select>
                              </td>                            
                            <td><input class="form-control" type="text" name="libele" [value]="item.libele"  /></td>  
                              
                          <td><input class="form-control" type="text" name="valeur" [value]="item.valeur" /></td>
                          <td class="col-md-2 col-sm-2"><i class="fas fa-solid fa-trash text-danger delete-contact" style="font-size: 20px;"></i></td> 
                          </tr>
                        </tbody>
                      </table>

                      
                    </div>
                    </div>
                </div>
                  
             </fieldset>
               </li>
            

               <li class="_tab-content _tab-content-3 typography" style="overflow: auto;">
                <br>
                <fieldset>
                  <div class="form-card"><br>
                  
                    <div class="container">
                      <div class="login-page">
                        <div class="form">
                          <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" class="login-form">
                            <input type="password" formControlName="currentPassword" placeholder="Mot de passe actuel" />
                            <div *ngIf="resetForm.get('currentPassword')?.touched && resetForm.get('currentPassword')?.invalid" class="text-danger">
                              Mot de passe actuel requis.
                            </div>
                            <input type="password" formControlName="password" placeholder="Nouveau mot de passe" />
                            <input type="password" formControlName="confirmPassword" placeholder="Resaisir nouveau mot de passe" />
                            
                            <div *ngIf="resetForm.errors?.passwordMismatch && resetForm.touched" class="text-danger">
                              Les mots de passe ne correspondent pas.
                            </div>
                          
                            <button type="submit"  [ngClass]="{'btn-disabled': resetForm.invalid, 'btn-enabled': resetForm.valid}" [disabled]="resetForm.invalid">Changer mot de passe</button>
                          </form>
                          
                        </div>
                      </div>
                    </div>
                    
    
                  </div>
                  
                </fieldset>
               </li>
  
  
  
  
  
           </ul>
  
         </div>
  
      </form>
      
       
     </div>
     <!-- <ngx-ui-loader></ngx-ui-loader> -->

  </body>
</html>



